import { Component } from '@angular/core';
import { BaseIndexPageComponent } from 'src/app/components/pages/base-index-page/base-index-page.component';
import BaseIndexPageConfig from 'src/app/components/pages/base-index-page/base-index-page.config';
import { DataTableColumnActions } from 'src/app/components/widgets/data-table/columns/data-table-column-actions/data-table-column-actions.config';
import { DataTableColumnText } from 'src/app/components/widgets/data-table/columns/data-table-column-text/data-table-column-text.config';
import ApiOptionsConfig from 'src/app/services/api/api-options.config';
import { ProjectsService } from 'src/app/services/api/projects.service';
import { RouteService } from 'src/app/services/route.service';

@Component({
  selector: 'app-projects-index-page',
  imports: [BaseIndexPageComponent],
  templateUrl: './projects-index-page.component.html',
  styleUrl: './projects-index-page.component.scss'
})
export class ProjectsIndexPageComponent {
ist: any[] = [];

  baseIndexPageConfig: BaseIndexPageConfig;

  constructor(
    protected projectsService: ProjectsService,
    private routeService: RouteService
  ) {
    this.baseIndexPageConfig = {
      pageTitle: 'Projects',
      cardTitle: 'Manage Projects',
      dataTable: {
      data: [],
      searchModel: {
        userId: null,
        firstName: null,
        lastName: null,
      },
      topInputFilters: [
          {
            label: 'Date From',
            attribute: 'projectTimeStart',
            type: 'date'
          },
          {
            label: 'Date To',
            attribute: 'projectTimeEnd',
            type: 'date'
          }
        ],
      pagination: null,
      columns: [
        new DataTableColumnText({
        attribute: 'code',
        header: 'Code',
        filter: 'text',
        value: (project: any) => {
          return project.code;
        }
        }),
        new DataTableColumnText({
        attribute: 'startTime',
        header: 'Start Time',
        value: (project: any) => {
          return project.startTime
;
        }
        }),
        new DataTableColumnText({
        attribute: 'companyName',
        header: 'Company',
        filter: 'text',
        value: (project: any) => {
          return project.clientCompanyName
;
        }
        }),
        new DataTableColumnText({
        attribute: 'summary',
        header: 'Summmary',
        filter: 'text',
        value: (project: any) => {
          return project.summary;
        }
        }),
        new DataTableColumnText({
        attribute: 'clientName',
        header: 'Client Name',
        filter: 'text',
        value: (project: any) => {
            return project.clientName;
          }
          }),
          new DataTableColumnText({
          attribute: 'requestCategoryId',
          header: 'Category',
          filter: 'select',
          filterOptionsSource:'categoryProposal',
          value: (project: any) => {
            return project.requestCategories
              ? project.requestCategories.map((c: any) => c.name).join(', ')
              : '';
          }
          }),
          new DataTableColumnText({
          attribute: 'status',
          header: 'Status',
          filter: 'select',
          filterOptionsSource:'projectStatus',
          value: (project: any) => {
          return project.status;
        }
        }),
        new DataTableColumnText({
        attribute: 'reviewed',
        header: 'Reviewed',
        value: (project: any) => {
          return project.testlistReviewedCount + '/' + project.testlistCount;
        }
        }),  
         new DataTableColumnText({
        attribute: 'archived',
        header: 'Archived',
        filter: 'select',
        filterOptionsSource:'archived',
        value: (project: any) => {
          return project.archived === true || project.archived === 1 ? 'Yes' : 'No';
        }
        }),        
        new DataTableColumnActions({
        header: 'Actions',
        attribute: 'actions',
        style: { width: '50px' },
        buttons: [
          {
          icon: 'fa-eye',
          tooltip: 'View project details',
          onClick: (project: any) => {
            this.routeService.projectsDetail(project.projectId);
          },
          hidden: false
          },
          {
          icon: 'fa-edit',
          tooltip: 'Edit project',
          onClick: (project: any) => {
            this.routeService.projectsUpdate(project.projectId);
          },          
          },
          {
          icon: 'bi bi-file-earmark-arrow-up-fill',
          tooltip: 'Export project',
          aclAction: 'export',
          onClick: (project: any) => {
          },
          hidden: false
          },
          {
          icon: 'fa-trash',
          tooltip: 'Delete project',
          onClick: (project: any) => {
          },
          hidden: false
          }
        ]
        })
      ]
      },
      apiListService: (options: ApiOptionsConfig) => this.projectsService.list(options),
      responseListModelName: 'projects',
    }
    
  }
}
